import { render, staticRenderFns } from "./CardContractZcc.vue?vue&type=template&id=271508be&scoped=true"
import script from "./CardContractZcc.vue?vue&type=script&lang=ts"
export * from "./CardContractZcc.vue?vue&type=script&lang=ts"
import style0 from "./CardContractZcc.vue?vue&type=style&index=0&id=271508be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271508be",
  null
  
)

export default component.exports